import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=00078b5a&"
import script from "./carousel.vue?vue&type=script&lang=js&"
export * from "./carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00078b5a')) {
      api.createRecord('00078b5a', component.options)
    } else {
      api.reload('00078b5a', component.options)
    }
    module.hot.accept("./carousel.vue?vue&type=template&id=00078b5a&", function () {
      api.rerender('00078b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/carousel/carousel.vue"
export default component.exports